export enum CallStatus {
  STATUS_REQUESTED = "requested", // user started call (i,o) 1
  STATUS_INITIATED = "initiated",
  STATUS_TRYING = "trying", // reached to asterisk (o) 2
  STATUS_RINGING = "ringing", //  (o)3
  STATUS_ONGOING = "ongoing", // received
  STATUS_FINISHED = "finished", // call ended successfully
  STATUS_FAILED = "failed", // general fail (system error)
  STATUS_MISSED = "missed", // customer missed call
  STATUS_REJECTED = "rejected", // 4(o) receiver rejected the call
  STATUS_SYSTEM_REJECTED = "system_rejected", // for incoming (when call center is closed)
  STATUS_AGENT_SELECTED = "agent_selected", // agent selected (before )
  STATUS_CUSTOMER_HUNG_UP_IN_DTMF = "customer_hungup_in_dtmf", // hung up in dtmf ( before press 1,2,3)
  STATUS_CUSTOMER_HUNG_UP_IN_QUEUE = "customer_hungup_in_queue", // hung up in queue ( after press 1,2,3)
  STATUS_CUSTOMER_TIMEOUT_IN_QUEUE = "customer_timeout_in_queue", // timeout in queue ( after press 1,2,3)
  STATUS_HUNG_UP_BEFORE_RECEIVED = "hungup_before_recieved", // ringing but caller rejected
}
